import React from "react";
import { ChevronRight } from "lucide-react";
import { GoogleAdSlot } from "./GoogleAdSlot";
import { GlobalUserSearch } from "./Header";

function HomeBigBanner() {
  return (
    <div className="card overflow-hidden mb-6 relative" data-testid="home-big-banner">
      <GoogleAdSlot
        slot="7225893051"
        mobileMinHeight={84}
        desktopMinHeight={230}
        testId="adsense-main-banner"
      />
    </div>
  );
}

function HomeTopicCard({ topic, onOpen }) {
  return (
    <button
      onClick={() => onOpen(topic.slug)}
      className="topic-tile block w-full text-left"
      data-testid={`home-topic-${topic.slug}`}
    >
      <div className="topic-thumb relative" style={{ background: `linear-gradient(135deg, ${topic.tint.join(", ")})`, aspectRatio: "16/10" }}>
        {topic.image && (
          <img
            src={topic.image}
            alt={topic.title}
            className="absolute inset-0 w-full h-full object-cover"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
        <div className="absolute bottom-3 left-3 right-3 text-white font-display font-semibold text-lg md:text-xl leading-tight drop-shadow-lg">
          {topic.title}
        </div>
      </div>
      <div className="px-4 py-3 bg-white flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-muted">Apri argomento</span>
        <ChevronRight size={14} className="text-primary" />
      </div>
    </button>
  );
}

export function HomeView({ topics, onSelectTopic }) {
  return (
    <div className="reveal" data-testid="home-view">
      <div className="flex items-center justify-between gap-2 mb-4" data-testid="home-heading-row">
        <h2 className="font-display font-semibold text-3xl sm:text-4xl md:text-5xl text-ink shrink-0">Argomenti</h2>
        <div className="hidden sm:block ml-auto w-[min(38vw,360px)]" data-testid="home-global-search">
          <GlobalUserSearch />
        </div>
        <div className="hidden lg:block text-xs uppercase tracking-widest text-muted shrink-0">Dieci temi fissi · 18+</div>
      </div>
      <HomeBigBanner />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-testid="home-topic-grid">
        {topics.map((t) => (
          <HomeTopicCard key={t.slug} topic={t} onOpen={onSelectTopic} />
        ))}
      </div>
      <p className="mt-6 text-center text-xs text-muted">
        Scegli un argomento per aprire il feed e iniziare a parlare. I dieci temi resteranno sempre visibili nella barra laterale.
      </p>
    </div>
  );
}

// HomeValuesSections was removed in iter21: value info is now modal-only from ValuesFooter.
